import React, { FC } from 'react';
import { SGText } from '@/shared/components/SGText/SGText';

type Props = {
  title: string;
  subject: string;
};

const CopilotBodyItem: FC<Props> = ({ title, subject }) => {
  return (
    <div className="copilot-body-item">
      <SGText.H5>{title}</SGText.H5>
      <div className="color-pale">{subject}</div>
    </div>
  );
};

export default CopilotBodyItem;
